module.exports = __webpack_public_path__ + "img/q11.b2a4e490.jpeg";